import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";

export const useMobile = (breakpoint = "sm") => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(breakpoint));
};
